import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { ICarrier } from "../../interfaces/configuration";

interface CarriersTableProps {
  carriers: ICarrier[];
  // eslint-disable-next-line no-unused-vars
  onToggle: (carrier: ICarrier) => void;
  updatingId: string | null;
}

export const CarriersTable: React.FC<CarriersTableProps> = ({
  carriers,
  onToggle,
  updatingId,
}) => (
  <TableContainer component={Paper} elevation={2} sx={{ maxWidth: 720 }}>
    <Table aria-label="tabla de operadores logísticos" size="small">
      <TableHead>
        <TableRow className="bg-light">
          <TableCell className="text-bold">Nombre</TableCell>
          <TableCell className="text-bold">Tipo</TableCell>
          <TableCell className="text-bold">Estado</TableCell>
          <TableCell align="center" className="text-bold">
            Acción
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {carriers.map((carrier) => {
          const isUpdating = updatingId === carrier._id;
          const carrierActionLabel = carrier.enabled ? "Deshabilitar" : "Habilitar";
          const buttonLabel = isUpdating ? "Guardando..." : carrierActionLabel;

          return (
            <TableRow key={carrier._id} className="menu-item-hover">
              <TableCell>
                <Typography variant="body2" className="text-bold">
                  {carrier.name}
                </Typography>
              </TableCell>

              <TableCell>
                <Chip
                  label={carrier.type === "PARTNER" ? "Partner" : "Tradicional"}
                  size="small"
                  color={carrier.type === "PARTNER" ? "primary" : "default"}
                  variant="outlined"
                />
              </TableCell>

              <TableCell>
                <Chip
                  label={carrier.enabled ? "Habilitado" : "Deshabilitado"}
                  size="small"
                  color={carrier.enabled ? "success" : "error"}
                />
              </TableCell>

              <TableCell align="center">
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    variant="contained"
                    size="small"
                    color={carrier.enabled ? "error" : "success"}
                    disabled={updatingId !== null}
                    startIcon={
                      isUpdating ? (
                        <CircularProgress size={16} color="inherit" />
                      ) : null
                    }
                    onClick={() => onToggle(carrier)}
                  >
                    {buttonLabel}
                  </Button>
                </Box>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  </TableContainer>
);
